import React from 'react';
import './Sub-services.css';
import ups from './assets/ups.png';

const RespaldoUPS = () => {
  return (
    <div className="containerSer">
      <h2>Sistemas de respaldo UPS</h2>
      <p>
        Los sistemas UPS (Uninterruptible Power Supply), son fuentes de
        alimentación ininterrumpida, son dispositivos que proporcionan energía
        de respaldo a los equipos eléctricos cuando hay un corte de energía o
        fluctuaciones de voltaje. Estos sistemas, son esenciales para proteger
        equipos delicados y evitar la pérdida de datos durante interrupciones
        del suministro eléctrico.
      </p>
      <img
        // Added objectFit
        src={ups}
        alt="ups sistema de respaldo IPSUM Uninterruptible Power Supply "
        className="panel-sucio-image"
      />
      <p>
        Ofrecemos asesoría, suministro e instalación de sistemas UPS adaptados a
        tus necesidades, brindando respaldo inmediato ante fallos eléctricos y
        asegurando una transición fluida a fuentes de energía alternativas.
      </p>
      <h3>Beneficios clave:</h3>
      <ul>
        <li>Protección ante cortes de energía y fluctuaciones eléctricas.</li>
        <li>Mayor vida útil para equipos electrónicos y sistemas críticos.</li>
        <li>Continuidad operativa sin interrupciones.</li>
        <li>Evita daño de equipos y perdida de información valiosa.</li>
        <li>Instalación y funcionamiento seguro.</li>
      </ul>
    </div>
  );
};

export default RespaldoUPS;
